<template>
  <div style="margin-left: 2rem; margin-right: 2rem">
    <v-sheet class="transparent-background-color">
      <v-row>
        <!-- GMV -->
        <v-col cols="12" md="3" class="pb-0">
          <v-card class="mb-6 v-card">
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-row class="v-row pb-2">
                <v-col cols="12" md="12" class="fs_2 d-lh">
                  {{ $t("Dashboard.gmv.title") }}
                  <v-icon x-small class="icon" :title="$t('Dashboard.gmv.info')"
                    >fa-info</v-icon
                  >
                </v-col>
              </v-row>
              <v-divider />
              <v-row
                class="v-row pt-5 row-active"
                @click="routePath('order', 'today')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.gmv.today") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.gmv.today
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row row-active"
                @click="routePath('order', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.gmv.yesterday") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.gmv.yesterday
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row pb-5 row-active"
                @click="routePath('order', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.gmv.difference") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? Math.abs(
                          dashboardData.gmv.yesterday - dashboardData.gmv.today
                        )
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- 日活 -->
        <v-col cols="12" md="3" class="pb-0">
          <v-card class="mb-6 v-card">
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-row class="v-row pb-2">
                <v-col cols="12" md="12" class="fs_2 d-lh">
                  {{ $t("Dashboard.daily_user.title") }}
                  <v-icon
                    x-small
                    class="icon"
                    :title="$t('Dashboard.daily_user.info')"
                    >fa-info</v-icon
                  >
                </v-col>
              </v-row>
              <v-divider />
              <v-row
                class="v-row pt-5 row-active"
                @click="routePath('order', 'today')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.daily_user.today") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  {{ dashboardData ? dashboardData.daily_user.today : 0 }}
                </v-col>
              </v-row>
              <v-row
                class="v-row row-active"
                @click="routePath('order', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.daily_user.yesterday") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  {{ dashboardData ? dashboardData.daily_user.yesterday : 0 }}
                </v-col>
              </v-row>
              <v-row
                class="v-row pb-5 row-active"
                @click="routePath('order', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.daily_user.difference") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  {{
                    dashboardData
                      ? Math.abs(
                          dashboardData.daily_user.yesterday -
                            dashboardData.daily_user.today
                        )
                      : 0
                  }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- 客单价 && 订单均价 -->
        <v-col cols="12" md="3" class="mt-n3">
          <v-card class="mb-6 v-card">
            <v-tabs
              v-model="tab_order"
              height="64"
              background-color="transparent"
              grow
            >
              <v-tab>
                <v-card-title class="pa-0 v-row">
                  {{ $t("Dashboard.customer_cost.title") }}
                  <v-icon
                    x-small
                    class="icon"
                    :title="$t('Dashboard.customer_cost.info')"
                    >fa-info</v-icon
                  >
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0 v-row">
                  {{ $t("Dashboard.order_average.title") }}
                  <v-icon
                    x-small
                    class="icon"
                    :title="$t('Dashboard.order_average.info')"
                    >fa-info</v-icon
                  >
                </v-card-title>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab_order" class="v-card">
              <!-- 客单价 -->
              <v-tab-item class="tab_item">
                <v-row
                  class="v-row pt-5 row-active"
                  @click="routePath('order', 'today')"
                >
                  <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                    {{ $t("Dashboard.customer_cost.today") }}
                  </v-col>
                  <v-col cols="8" class="fs_3 d-lh tr v-col">
                    <span class="fs_unit">
                      {{ $t("Global.money") }} </span
                    >{{
                      dashboardData
                        ? dashboardData.customer_cost.today
                        : 0 | formatMoneyFloorWithTwoDot(true)
                    }}
                  </v-col>
                </v-row>
                <v-row
                  class="v-row row-active"
                  @click="routePath('order', 'yesterday')"
                >
                  <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                    {{ $t("Dashboard.customer_cost.yesterday") }}
                  </v-col>
                  <v-col cols="8" class="fs_3 d-lh tr v-col">
                    <span class="fs_unit">
                      {{ $t("Global.money") }} </span
                    >{{
                      dashboardData
                        ? dashboardData.customer_cost.yesterday
                        : 0 | formatMoneyFloorWithTwoDot(true)
                    }}
                  </v-col>
                </v-row>
                <v-row
                  class="v-row pb-5 row-active"
                  @click="routePath('order', 'yesterday')"
                >
                  <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                    {{ $t("Dashboard.customer_cost.difference") }}
                  </v-col>
                  <v-col cols="8" class="fs_3 d-lh tr v-col">
                    <span class="fs_unit">
                      {{ $t("Global.money") }}
                    </span>
                    {{
                      dashboardData
                        ? Math.abs(
                            dashboardData.customer_cost.yesterday -
                              dashboardData.customer_cost.today
                          )
                        : 0 | formatMoneyFloorWithTwoDot(true)
                    }}
                  </v-col>
                </v-row>
              </v-tab-item>
              <!-- 订单均价 -->
              <v-tab-item class="tab_item">
                <v-row
                  class="v-row pt-5 row-active"
                  @click="routePath('order', 'today')"
                >
                  <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                    {{ $t("Dashboard.order_average.today") }}
                  </v-col>
                  <v-col cols="8" class="fs_3 d-lh tr v-col">
                    <span class="fs_unit">
                      {{ $t("Global.money") }} </span
                    >{{
                      dashboardData
                        ? dashboardData.order_average.today
                        : 0 | formatMoneyFloorWithTwoDot(true)
                    }}
                  </v-col>
                </v-row>
                <v-row
                  class="v-row row-active"
                  @click="routePath('order', 'yesterday')"
                >
                  <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                    {{ $t("Dashboard.order_average.yesterday") }}
                  </v-col>
                  <v-col cols="8" class="fs_3 d-lh tr v-col">
                    <span class="fs_unit">
                      {{ $t("Global.money") }} </span
                    >{{
                      dashboardData
                        ? dashboardData.order_average.yesterday
                        : 0 | formatMoneyFloorWithTwoDot(true)
                    }}
                  </v-col>
                </v-row>
                <v-row
                  class="v-row pb-5 row-active"
                  @click="routePath('order', 'yesterday')"
                >
                  <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                    {{ $t("Dashboard.order_average.difference") }}
                  </v-col>
                  <v-col cols="8" class="fs_3 d-lh tr v-col">
                    <span class="fs_unit">
                      {{ $t("Global.money") }}
                    </span>
                    {{
                      dashboardData
                        ? Math.abs(
                            dashboardData.order_average.yesterday -
                              dashboardData.order_average.today
                          )
                        : 0 | formatMoneyFloorWithTwoDot(true)
                    }}
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
        <!--        <v-col cols="12" md="3" class="pb-0">-->
        <!--          <v-card class="mb-6 v-card">-->
        <!--            <v-card-text class="mt-n3 pt-0 pb-1">-->
        <!--              <v-row class="v-row pb-2">-->
        <!--                <v-col cols="12" md="12" class="fs_2 d-lh">-->
        <!--                  {{ $t("Dashboard.customer_cost.title") }}-->
        <!--                  <v-icon x-small class="icon" :title="$t('Dashboard.customer_cost.info')">fa-info</v-icon>-->
        <!--                </v-col>-->
        <!--              </v-row>-->
        <!--              <v-divider />-->
        <!--              <v-row class="v-row pt-5 row-active" @click="routePath('order', 'today')">-->
        <!--                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">-->
        <!--                  {{ $t("Dashboard.customer_cost.today") }}-->
        <!--                </v-col>-->
        <!--                <v-col cols="8" class="fs_3 d-lh tr v-col">-->
        <!--                   <span class="fs_unit">-->
        <!--                    {{ $t("Global.money") }}-->
        <!--                  </span>{{ dashboardData ? (dashboardData.customer_cost.today): 0 | formatMoneyFloorWithTwoDot(true) }}-->
        <!--                </v-col>-->
        <!--              </v-row>-->
        <!--              <v-row class="v-row row-active" @click="routePath('order', 'yesterday')">-->
        <!--                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">-->
        <!--                  {{ $t("Dashboard.customer_cost.yesterday") }}-->
        <!--                </v-col>-->
        <!--                <v-col cols="8" class="fs_3 d-lh tr v-col">-->
        <!--                   <span class="fs_unit">-->
        <!--                    {{ $t("Global.money") }}-->
        <!--                  </span>{{ dashboardData ? (dashboardData.customer_cost.yesterday): 0 | formatMoneyFloorWithTwoDot(true) }}-->
        <!--                </v-col>-->
        <!--              </v-row>-->
        <!--              <v-row class="v-row pb-5 row-active" @click="routePath('order', 'yesterday')">-->
        <!--                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">-->
        <!--                  {{ $t("Dashboard.customer_cost.difference") }}-->
        <!--                </v-col>-->
        <!--                <v-col cols="8" class="fs_3 d-lh tr v-col">-->
        <!--                  <span class="fs_unit">-->
        <!--                    {{ $t("Global.money") }}-->
        <!--                  </span>-->
        <!--                  {{ dashboardData ? Math.abs(dashboardData.customer_cost.yesterday - dashboardData.customer_cost.today): 0 | formatMoneyFloorWithTwoDot(true) }}-->
        <!--                </v-col>-->
        <!--              </v-row>-->
        <!--            </v-card-text>-->
        <!--          </v-card>-->
        <!--        </v-col>-->
        <!-- 服务费 -->
        <v-col cols="12" md="3" class="pb-0">
          <v-card class="mb-6 v-card">
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-row class="v-row pb-2">
                <v-col cols="12" md="12" class="fs_2 d-lh">
                  {{ $t("Dashboard.service_charge.title") }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row
                class="v-row pt-5 row-active"
                @click="routePath('service_charge', 'today')"
              >
                <v-col cols="5" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.service_charge.today") }}
                </v-col>
                <v-col cols="7" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.service_charge.today
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row row-active"
                @click="routePath('service_charge', 'yesterday')"
              >
                <v-col cols="5" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.service_charge.yesterday") }}
                </v-col>
                <v-col cols="7" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.service_charge.yesterday
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row pb-5 row-active"
                @click="routePath('service_charge', 'yesterday')"
              >
                <v-col cols="5" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.service_charge.difference") }}
                </v-col>
                <v-col cols="7" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? Math.abs(
                          dashboardData.service_charge.yesterday -
                            dashboardData.service_charge.today
                        )
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- 运费 && 售后 && 毛利 -->
        <v-col cols="12" md="3" class="pb-0">
          <!-- 运费 -->
          <v-card class="mb-6 v-card">
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-row class="v-row pb-2">
                <v-col cols="12" md="12" class="fs_2 d-lh">
                  {{ $t("Dashboard.logistic_price.title") }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row
                class="v-row pt-5 row-active"
                @click="routePath('logistic_price', 'today')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.logistic_price.today") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.logistic_price.today
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row row-active"
                @click="routePath('logistic_price', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.logistic_price.yesterday") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.logistic_price.yesterday
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row pb-5 row-active"
                @click="routePath('logistic_price', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.logistic_price.difference") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? Math.abs(
                          dashboardData.logistic_price.yesterday -
                            dashboardData.logistic_price.today
                        )
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- 毛利 -->
          <v-card class="mb-6 v-card card_mt">
            <v-card-text class="pt-0 pb-1">
              <v-row class="v-row pb-2">
                <v-col cols="12" md="12" class="fs_2 d-lh">
                  {{ $t("Dashboard.gross_profit.title") }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row
                class="v-row pt-5 row-active"
                @click="routePath('material_profit', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.gross_profit.material") }}
                  <v-icon
                    x-small
                    class="icon"
                    :title="$t('Dashboard.gross_profit.material_info')"
                    >fa-info</v-icon
                  >
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.gross_profit.material
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row pb-5 row-active"
                @click="routePath('shop_profit', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.gross_profit.shop") }}
                  <v-icon
                    x-small
                    class="icon"
                    :title="$t('Dashboard.gross_profit.shop_info')"
                    >fa-info</v-icon
                  >
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.gross_profit.shop
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- 售后 -->
          <v-card class="mb-6 v-card card_mt">
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-row class="v-row pb-2">
                <v-col cols="12" md="12" class="fs_2 d-lh">
                  {{ $t("Dashboard.after_sales.title") }}
                </v-col>
              </v-row>
              <v-divider />
              <v-row
                class="v-row pt-5 row-active"
                @click="routePath('return_order', 'today')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.after_sales.today_num") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  {{ dashboardData ? dashboardData.after_sales.today.num : 0 }}
                </v-col>
              </v-row>
              <v-row
                class="v-row row-active"
                @click="routePath('return_order', 'today')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.after_sales.today_price") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.after_sales.today.price
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row row-active"
                @click="routePath('return_order', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.after_sales.yesterday_num") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  {{
                    dashboardData ? dashboardData.after_sales.yesterday.num : 0
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row row-active"
                @click="routePath('return_order', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.after_sales.yesterday_price") }}
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  <span class="fs_unit">
                    {{ $t("Global.money") }} </span
                  >{{
                    dashboardData
                      ? dashboardData.after_sales.yesterday.price
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                </v-col>
              </v-row>
              <v-row
                class="v-row pb-5 row-active"
                @click="routePath('return_order', 'yesterday')"
              >
                <v-col cols="4" class="fs_1 d-lh tl v-col left_col">
                  {{ $t("Dashboard.after_sales.difference") }}
                  <v-icon
                    x-small
                    class="icon after_sales_icon"
                    :title="$t('Dashboard.after_sales.difference_info')"
                    >fa-info</v-icon
                  >
                </v-col>
                <v-col cols="8" class="fs_3 d-lh tr v-col">
                  {{
                    dashboardData
                      ? dashboardData.after_sales.difference
                      : 0 | formatMoneyFloorWithTwoDot(true)
                  }}
                  <span class="fs_unit">
                    {{ $t("Global.rate") }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- 图表 -->
        <v-col cols="12" md="6" class="pb-0">
          <v-card class="mb-6 v-card">
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-row class="v-row pb-2">
                <v-col cols="12" md="12" class="fs_2 d-lh">
                  {{ $t("Dashboard.order_chart.title") }}
                </v-col>
              </v-row>
              <v-divider />
              <div id="chart" style="height: 53.5vh"></div>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- 当日TOP -->
        <v-col cols="12" md="3" class="mt-n3">
          <v-card class="mb-6 v-card">
            <v-tabs
              v-model="tab"
              height="64"
              background-color="transparent"
              grow
            >
              <v-tab>
                <v-card-title class="pa-0 v-row">
                  {{ $t("Dashboard.day_top.num") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0 v-row">
                  {{ $t("Dashboard.day_top.price") }}
                </v-card-title>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" class="v-card">
              <v-tab-item
                v-show="
                  dashboardData &&
                  dashboardData.day_top &&
                  dashboardData.day_top.sale.length
                "
              >
                <v-data-table
                  :headers="saleHeaders"
                  :items="
                    dashboardData && dashboardData.day_top
                      ? dashboardData.day_top.sale
                      : []
                  "
                  multi-sort
                  class="pb-2 v-card v-row br-0 row-active"
                  hide-default-header
                  hide-default-footer
                  disable-pagination
                  no-data-text=""
                  @click:row="routePath('material_sales', 'today')"
                >
                  <template v-slot:header.material_name="{ header }">
                    <span class="v-row">
                      {{ header.text }}
                    </span>
                  </template>
                  <template v-slot:header.num="{ header }">
                    <span class="v-row">
                      {{ header.text }}
                    </span>
                  </template>
                  <template v-slot:item.num="{ item }">
                    <span class="fc">
                      {{ item.num | formatMoneyFloorWithTwoDot }}
                    </span>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item
                v-show="
                  dashboardData &&
                  dashboardData.day_top &&
                  dashboardData.day_top.sale_price.length
                "
              >
                <v-data-table
                  :headers="salePriceHeaders"
                  :items="
                    dashboardData && dashboardData.day_top
                      ? dashboardData.day_top.sale_price
                      : []
                  "
                  multi-sort
                  class="pb-2 v-card v-row br-0 row-active"
                  hide-default-header
                  hide-default-footer
                  disable-pagination
                  no-data-text=""
                  @click:row="routePath('material_sales', 'today')"
                >
                  <template v-slot:header.material_name="{ header }">
                    <span class="v-row">
                      {{ header.text }}
                    </span>
                  </template>
                  <template v-slot:header.total_price="{ header }">
                    <span class="v-row">
                      {{ header.text }}
                    </span>
                  </template>
                  <template v-slot:item.total_price="{ item }">
                    <span class="fc">
                      <span class="fs_unit">
                        {{ $t("Global.money") }} </span
                      >{{ item.total_price | formatMoneyFloorWithTwoDot }}
                    </span>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<style scoped>
.v-card {
  background-color: #1a2b4d !important;
}
.v-row {
  text-align: center;
  color: #ccc !important;
  padding-top: 0;
  padding-right: 0.5rem !important;
  padding-bottom: 0;
  padding-left: 0.5rem !important;
}
.v-col {
  padding-top: 0;
  padding-right: 0.5rem;
  padding-bottom: 0.2rem;
  padding-left: 0.5rem;
}
.v-icon {
  margin-top: -1rem;
  cursor: pointer;
  color: #ccc !important;
}
.left_col {
  padding-top: 0.25rem;
}
.v-divider {
  background-color: #0071a1;
}

.fs_1 {
  font-size: 1rem !important;
}
.fs_2 {
  font-size: 1.4rem;
}
.fs_3 {
  font-size: 1.4rem;
  color: #4d9fff;
}
.fs_unit {
  font-size: 1rem !important;
}
.tl {
  text-align: left;
}
.tr {
  text-align: right;
}
.fc {
  color: #4d9fff;
}
.d-lh {
  line-height: 2.5rem !important;
}
.card_mt {
  margin-top: 2.5rem !important;
}
.br-0 {
  border-radius: 0px;
}
.v-application .primary--text {
  color: #0071a1 !important;
  caret-color: #0071a1 !important;
}
tr:active {
  background-color: #0071a1 !important;
}
tr:hover {
  background-color: #0071a1 !important;
}
.row-active {
  cursor: pointer;
}
.tab_item {
  margin-left: 1rem;
  margin-right: 1rem;
}
</style>

<script>
var intervalRef = void 0;
var notifyDisplayed = 0;
import { mapState } from "vuex";
import * as echarts from "echarts";
import i18n from "@/i18n";
import Top from "@/api/top";

export default {
  components: {},

  data: () => ({
    chart: null,
    tab: 0,
    tab_order: 0,
    order_chart: [],
    dashboardData: null,
  }),

  computed: {
    saleHeaders: () => [
      {
        text: i18n.t("Dashboard.day_top.material_name"),
        align: "start",
        value: "material_name",
      },
      {
        text: i18n.t("Dashboard.day_top.sale_num"),
        align: "end",
        value: "num",
      },
    ],
    salePriceHeaders: () => [
      {
        text: i18n.t("Dashboard.day_top.material_name"),
        align: "start",
        value: "material_name",
      },
      {
        text: i18n.t("Dashboard.day_top.sale_price"),
        align: "end",
        value: "total_price",
      },
    ],
    ...mapState(["accountUser", "settings"]),
  },

  mounted() {
    this.getDashboardData();
    let _this = this;
    // 获取当前时间
    let now = new Date();
    let min = now.getMinutes();
    let sec = now.getSeconds();
    let msUntilNextHour = 0;
    if (min > 30) {
      // 计算距离下一个整点的时间（毫秒）
      msUntilNextHour = (60 - min - 1) * 60 * 1000 + (60 - sec) * 1000;
    } else {
      // 计算距离下一个半点的时间（毫秒）
      msUntilNextHour = (30 - min - 1) * 60 * 1000 + (60 - sec) * 1000;
    }
    // 设置setTimeout，以在下一个整点报时
    setTimeout(function () {
      _this.getDashboardData();
      intervalRef = setInterval(() => {
        if (!notifyDisplayed) {
          _this.getDashboardData();
        }
      }, 1800000);
    }, msUntilNextHour);
  },
  methods: {
    getDashboardData() {
      Top.getDashboardData().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.dashboardData = response.data.data;
            this.order_chart = response.data.data.order_chart.map((data) => {
              return {
                value: data.value,
                name: data.name,
              };
            });
            if (this.order_chart.length > 0) {
              this.orderChart();
            }
          }
        }.bind(this)
      );
    },
    orderChart() {
      if (this.chart != null && this.chart != "" && this.chart != undefined) {
        this.chart.dispose(); //销毁
      }
      this.chart = echarts.init(document.getElementById("chart"));

      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} 元 ({d}%)",
        },
        legend: {
          top: "90%",
          left: "center",
          textStyle: {
            color: "#ccc",
            fontWeight: "normal",
          },
        },
        series: [
          {
            name: "",
            top: "-20%",
            type: "pie",
            radius: [50, 150],
            center: ["50%", "50%"],
            roseType: "area",
            itemStyle: {
              borderRadius: 8,
            },
            label: {
              formatter: "{b}: {c} 元 ({d}%)",
              textStyle: {
                color: "#ccc",
                fontWeight: "normal",
              },
            },
            data: this.order_chart,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
    },
    routePath(type, time) {
      let url = "";
      // 品牌端订单一览
      if (type == "order") {
        url = "/#/orders/";
        let ordersOptions = {
          datetimeRadioSelected: "created",
          actual_time_from: "",
          actual_time_to: "",
          expect_time_from: "",
          expect_time_to: "",
          order_code: "",
          ext_code: "",
          origin_flgs: [],
          shop_ids: [],
          no_children_district_codes: [],
          alliance_business_ids: [],
          status: [1, 2, 3, 4, 5, 6],
          pay_flgs: [1, 2, 3],
          presale_flgs: [0, 1],
          cancel_flgs: [0],
          sortBy: [],
          sortDesc: [],
          material_ids: [],
        };
        if (time == "today") {
          ordersOptions.created_time_from =
            new Date(new Date().getTime()).toISOString().substr(0, 10) +
            " 00:00:00";
          ordersOptions.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        }
        if (time == "yesterday") {
          ordersOptions.created_time_from =
            new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
          ordersOptions.created_time_to =
            new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 23:59:59";
        }
        this.$store.commit("navName", i18n.t("Nav.orders"));
        sessionStorage.setItem("orders-options", JSON.stringify(ordersOptions));
        window.open(url, "_blank");
      }
      // 品牌端退货订单一览
      if (type == "return_order") {
        url = "/#/return-orders/";
        let options = {
          datetimeRadioSelected: "created",
          actual_time_from: "",
          actual_time_to: "",
          expect_time_from: "",
          expect_time_to: "",
          order_code: "",
          ext_code: "",
          for_order_code: "",
          origin_flgs: [],
          shop_ids: [],
          district_codes: [],
          alliance_business_ids: [],
          status: [1, 2, 3, 4],
          pay_flgs: [1, 2, 3],
          cancel_flgs: [0],
          sortBy: [],
          sortDesc: [],
          material_ids: [],
          return_type: [1, 2],
          memo: "",
          return_origin_flgs: [1, 2],
        };
        if (time == "today") {
          options.created_time_from =
            new Date(new Date().getTime()).toISOString().substr(0, 10) +
            " 00:00:00";
          options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        }
        if (time == "yesterday") {
          options.created_time_from =
            new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
          options.created_time_to =
            new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 23:59:59";
        }
        this.$store.commit("navName", i18n.t("Nav.orders"));
        sessionStorage.setItem(
          "return-orders-options",
          JSON.stringify(options)
        );
        window.open(url, "_blank");
      }
      // 智能报表 -- 订单运费统计
      if (type == "logistic_price") {
        url =
          this.$ReportURL +
          localStorage.getItem("accessToken") +
          "/" +
          encodeURIComponent("/order-freight") +
          "?dateType=" +
          time;
        window.open(url, "_blank");
      }
      // 智能报表 -- 订单服务费统计
      if (type == "service_charge") {
        url =
          this.$ReportURL +
          localStorage.getItem("accessToken") +
          "/" +
          encodeURIComponent("/order-service") +
          "?dateType=" +
          time;
        window.open(url, "_blank");
      }
      // 智能报表 -- 商品毛利
      if (type == "material_profit") {
        url =
          this.$ReportURL +
          localStorage.getItem("accessToken") +
          "/" +
          encodeURIComponent("/material-profit") +
          "?dateType=" +
          time;
        window.open(url, "_blank");
      }
      // 智能报表 -- 门店毛利
      if (type == "shop_profit") {
        url =
          this.$ReportURL +
          localStorage.getItem("accessToken") +
          "/" +
          encodeURIComponent("/shop-profit") +
          "?dateType=" +
          time;
        window.open(url, "_blank");
      }
      // 智能报表 -- 商品销量
      if (type == "material_sales") {
        url =
          this.$ReportURL +
          localStorage.getItem("accessToken") +
          "/" +
          encodeURIComponent("/material-sales") +
          "?dateType=" +
          time;
        window.open(url, "_blank");
      }
    },
  },
  beforeDestroy() {
    clearInterval(intervalRef);
    intervalRef = void 0;
  },
};
</script>